import { Icon } from './hbs/Icon';

export default function CardsEmptyPanel(): JSX.Element {
  return (
    <div className="h-full flex flex-col items-center justify-center text-center p-8 text-hbs-text-mute">
      <Icon name="card" size={56} className="text-hbs-text-mute mb-3" />
      <h2 className="font-display text-[20px] text-hbs-text mb-1">Select a payment card</h2>
      <p className="text-[13px] max-w-xs">
        Choose a payment card from the list to see its details, or add a new one with the + button.
      </p>
    </div>
  );
}
